export interface AudioTrack {
    id?: string;
    name?: string;
    description?: string;
    tags?: string;
    audio_type?: AudioType;
    preview_url?: string;
    file_url?: string;
    file_id?: string;
    duration?: number;
    is_public?: boolean;
    organization_id?: string;
    created_at?: string;
    updated_at?: string;
    created_by?: string;
    updated_by?: string;
}

export enum AudioType {
    MUSIC = "music",
    SPOKEN = "spoken"
}
